const state = {
    property: [],
    property_type: [],
    LocationItems: [],
    Loadings: {
        list: false,
    },
};

const getters = {
    ListPropertyType: (state) => state.property_type,
    LocationItems: (state) => state.LocationItems
};

const actions = {
    async saveProperty({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/contracts/${params.contract_id}/properties`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('StatusController/setProperty', { key: 'equipment', value: true }, { root: true });
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updateProperty({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/contracts/${params.contract_id}/properties/${params.id}`, {
                    method: "PUT",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('StatusController/setProperty', { key: 'equipment', value: true }, { root: true });
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async removeProperty({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/contracts/${params.contract_id}/properties/${params.id}`, {
                    method: "DELETE",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('StatusController/setProperty', { key: 'equipment', value: true }, { root: true });
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getListPropertyType({ commit }) {
        return new Promise((resolve, reject) => {
            global.axios(`api/property-types`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('ListPropertyType', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async uploadFileImport({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('file_import', params.fileImport);
            global.axios.post(`api/contracts/${params.contract_id}/properties/import`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {

                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
    async saveCheckedProperties({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/s-contracts/properties`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getListLocations({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/contracts/${params.contract_id}/properties/${params.property_id}/location`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('setListLocation', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async exportPropertySchedule({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/contracts/${params.contract_id}/properties/${params.property_id}/location/export_schedule`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async createNewRoomInventorySet({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.post(`api/room-inventory-sets`, params)
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    // commit( 'setListLocation', response.data.data );
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async checkNewRoomInventorySet({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.post(`api/room-inventory-sets/check`, params)
                .then(response => {
                    //commit( 'setLoadings', {key:"list",val:false});
                    // commit( 'setListLocation', response.data.data );
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async deleteRoomInventorySet({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/room-inventory-sets`, {
                    method: "DELETE",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getListRoomInventory({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/room-inventory`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    // commit( 'setListLocation', response.data.data );
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getInventorySetOptions({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/room-inventory-sets`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async checkCanCreateInventory({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/room-inventory/check?property_id=` + params.property_id, {
                    method: "GET",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async createRoomInventory({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/room-inventory`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updateRoomInventory({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/room-inventory/${params.id}`, {
                    method: "PUT",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async deleteRoomInventory({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/room-inventory`, {
                    method: "DELETE",
                    data: {
                        ids: params.ids,
                        room_inventory_set_id: params.room_inventory_set_id
                    },
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async removeInventory({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/room-inventory/`, {
                    method: "DELETE",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async getReferences({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/references`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async massUpdate({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/contracts/${params.contract_id}/properties`, {
                    method: "PUT",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async exportCsv({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/contracts/${params.contract_id}/properties/${params.property_id}/location/export`, {
                    params: params,
                    responseType: 'blob'
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getTreeProperties({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/properties/tree`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getSearchProperties({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/properties/search`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async checkPropertyScheduledJob({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/properties/check-existing-property-schedule-job`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async createPropertySchedule({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/properties/generate-jobs-property-schedule`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getCustomFieldProperties({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/hdb-inspection/custom-field-properties/` + params.property_id, {
                method: "GET",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    async saveCustomFieldProperties({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/hdb-inspection/custom-field-properties`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    importHDBInspection({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.file);
            formData.append('contract_id',params.contract_id);
            commit( 'setLoadings', {key: "import",val: true} );
            global.axios.post(`api/hdb-inspection/import`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    commit( 'setLoadings', {key: "import",val: false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setLoadings', {key: "import",val: false} );
                    reject( error )
                } );
        });
    },
    // NLT Properties
    async getListNLTProperties({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/nlt-properties`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async checkExistingPostalCode({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/nlt-properties/check-existing-postal-code`, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
};

const mutations = {
    ListPropertyType(state, property_type) {
        state.property_type = property_type
    },
    setListLocation(state, data) {
        state.LocationItems = data;
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}